import { routeTree } from '@/routeTree.gen';
import { createRouter, Link } from '@tanstack/react-router';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultNotFoundComponent: () => {
    return (
      <div className="flex h-svh flex-col items-center justify-center gap-4">
        <p className="text-2xl font-bold">
          Diese Seite existiert nicht.
        </p>
        <Link
          to="/"
          className="text-primary"
        >
          Zur Startseite
        </Link>
      </div>
    );
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
